import { GetterTree } from "vuex";
import { ModalAction, ModalState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<ModalState, any> = {
  //getIsOpen
  [defineVuexName(MODULES.MODAL.GETTERS.GET_IS_OPEN)](state: ModalState): boolean {
    return state.isOpen;
  },
  //getTitle
  [defineVuexName(MODULES.MODAL.GETTERS.GET_TITLE)](state: ModalState): string {
    return state.title;
  },
  //getActions
  [defineVuexName(MODULES.MODAL.GETTERS.GET_ACTIONS)](state: ModalState): ModalAction[] | undefined {
    return state.actions;
  },
  //getView
  [defineVuexName(MODULES.MODAL.GETTERS.GET_VIEW)](state: ModalState): object {
    return state.view;
  },
  //getProps
  [defineVuexName(MODULES.MODAL.GETTERS.GET_PROPS)](state: ModalState): object {
    return state.props;
  },
  //getIsSubmitting
  [defineVuexName(MODULES.MODAL.GETTERS.GET_IS_SUBMITTING)](state: ModalState): boolean {
    return state.isSubmitting;
  },
  [defineVuexName(MODULES.MODAL.GETTERS.NAME)](s: ModalState) {
    return s.name;
  },
};

export default getters;
